module.exports = __webpack_public_path__ + "static/ICNlogo-6c78c76e6b892fe1fd050d4c92fa8eba.webp";